import type { WallFramingOpeningSettings } from "building-types/settings/wallFramingOpeningSettings";
import { UnionType } from "building-types/walls/wallFramingTypes";
import {
  mergePartialBooleanField,
  mergePartialField,
  mergePartialMinNumberField,
  mergePartialTruthyField,
} from "common/utils/partialRecordMerge";

function mergePartialHasHeaderAssemblyField(
  unioned: Partial<WallFramingOpeningSettings>,
  toMerge: Partial<WallFramingOpeningSettings> | undefined,
): void {
  mergePartialField(unioned, toMerge, "hasHeaderAssembly", (left, right) => {
    if (left === false || right === false) {
      return false;
    }
    return (left || right) as boolean;
  });
}

/**
 * Unioning framing settings is not as straightforward as a spread or a boolean union:
 * undefined values need to be handled correctly.
 */
export function unionFramingSettings(
  framingSettings: Partial<WallFramingOpeningSettings | undefined>[],
  union: UnionType = UnionType.OR,
): Partial<WallFramingOpeningSettings> {
  const unioned: Partial<WallFramingOpeningSettings> = {};

  for (const toMerge of framingSettings) {
    mergePartialBooleanField(unioned, toMerge, "hasCrippleStudEnds", union);
    mergePartialBooleanField(unioned, toMerge, "hasCrippleStudsBelowOpening", union);
    mergePartialBooleanField(unioned, toMerge, "hasCrippleStudsAboveOpening", union);
    mergePartialBooleanField(unioned, toMerge, "hasTopHeaderSillPlate", union);
    mergePartialHasHeaderAssemblyField(unioned, toMerge);
    mergePartialTruthyField(unioned, toMerge, "headerAssemblyId");
    mergePartialTruthyField(unioned, toMerge, "numberOfJackStuds");
    mergePartialTruthyField(unioned, toMerge, "numberOfKingStuds");
    mergePartialMinNumberField(unioned, toMerge, "roughOpeningBorder");
  }
  return unioned;
}
